export default "__VITE_ASSET__5cd7761f__"